import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const TOKEN_KEY = "nms_token";

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem(TOKEN_KEY);
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (error) => {
    if (error?.response?.status === 401 && !error.config?.url?.includes("/auth/login")) {
      localStorage.removeItem(TOKEN_KEY);
      window.dispatchEvent(new Event("nms-logout"));
    }
    return Promise.reject(error);
  },
);

export function errMsg(e: any): string {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Erreur inattendue";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => `${x.loc?.slice(-1)[0]} : ${x.msg}`).join(" · ");
  return d.message || JSON.stringify(d);
}

export async function openPdf(kind: string, id: string, path = `/pdf/${kind}/${id}`) {
  const win = window.open("", "_blank");
  let res;
  try {
    res = await api.get(path, { responseType: "blob" });
  } catch (e) {
    win?.close();
    throw e;
  }
  const url = URL.createObjectURL(res.data);
  if (win) {
    win.location.href = url;
  } else {
    const a = document.createElement("a");
    a.href = url;
    a.download = `${kind}-${id}.pdf`;
    a.click();
  }
}
